module.exports = __webpack_public_path__ + "static/media/congrats.21470baf.svg";